import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorIncapacidadesEliminarComponent {
  idProyecto
  idColaborador
  indice
  data
  onClose
  procesando = false
  eliminado = false
  eliminable = false
  error = null

  constructor ($filter, ColaboradorIncapacidad) {
    this.ColaboradorIncapacidad = ColaboradorIncapacidad
  }

  $onInit () {
    this.eliminable = !this.data.pagos || !this.data.pagos.length
  }

  cerrar () {
    this.onClose({$event: {detail: {eliminado: this.eliminado}}})
  }

  eliminar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.ColaboradorIncapacidad.delete(this.idProyecto, this.idColaborador, this.indice)
      .then(() => {
        this.eliminado = true
        this.cerrar()
      })
      .catch(({data}) => this.error = data)
      .finally(() => (this.procesando = false))
  }
}

module.component('colaboradorIncapacidadesEliminar', {
  controller: ColaboradorIncapacidadesEliminarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    indice: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/incapacidades/eliminar/component.js